import React from "react";
import { cn } from "../../lib/utils";

interface PageSectionProps {
  children: React.ReactNode;
  className?: string;
}

export const PageSection: React.FC<PageSectionProps> = ({
  children,
  className = "",
}) => {
  return (
    <div className={cn(`flex w-full justify-center`, className)}>
      <div className="w-full max-w-[1440px] px-6 md:px-16">{children}</div>
    </div>
  );
};
